import { useEffect, useRef, useState } from "react"
import styled from "styled-components/macro"
import gsap from "gsap"
import { useStore } from "@state/store"
import { PLAN_OVERRIDE } from "./ResidenceGeneric/FloorplanImage"

const ImageOverlay = ({ selectedUnit, controlIndex = null }) => {
  const imageRef = useRef()
  const imageOverlay = useStore((s) => s.imageOverlay)

  useEffect(() => {
    gsap.to(imageRef.current, {
      autoAlpha: imageOverlay ? 1 : 0,
      duration: 0.6,
    })
  }, [imageOverlay])

  let imgSrc

  if (selectedUnit) {
    const name = selectedUnit?.[0]?.id
    imgSrc = PLAN_OVERRIDE[name] ?? `assets/floorPlanMedia/${selectedUnit?.[0]?.unitType}.svg`
  }

  return (
    <Wrapper ref={imageRef} className="imageOverlay">
      {selectedUnit && <img src={imgSrc} alt={"floorplan"} />}
    </Wrapper>
  )
}

export default ImageOverlay

const Wrapper = styled.div`
  padding: 3rem;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5;
  background-color: white;
  display: flex;

  img {
    margin: auto;
    width: 80%;
    height: 100%;
    object-fit: contain;
    mix-blend-mode: multiply;
  }
`
